import { livefireItemTypes } from '@bblabs/module-library/constants';
import { getSettingsService } from '../services/SettingsService';

// build our record of default livefire filters (everything on!)
const defaultFilters: Record<string, boolean> = Object.values<string | boolean>(
  livefireItemTypes.items,
).reduce((acc, value) => {
  // livefireItemTypes includes a couple of items we want to skip (EVENT_TYPES, EMAIL_TYPES, etc).
  // we will only include items are a string.
  if (typeof value === 'string') {
    acc[value] = true;
  }

  return acc;
}, {} as Record<string, boolean>);

export function useLivefireFilters() {
  const settings = getSettingsService('bombbomb');

  function onFilterStateChange(change: Record<string, boolean>) {
    settings.set('livefireFilters', change, true);
  }

  const filters = settings.get('livefireFilters');
  const filterState = filters ? { ...defaultFilters, ...filters } : defaultFilters;

  return { filterState, onFilterStateChange };
}
